import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AddStockForm } from '../../../../components/admin-dashboard-component/products/add-stock-form/add-stock-form';

@Component({
  selector: 'app-add-stock',
  imports: [AddStockForm],
  templateUrl: './add-stock.html',
  styleUrl: './add-stock.scss',
})
export class AddStock implements OnInit {
  productId: number | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const id = this.route.snapshot.params['id'];
    this.productId = id ? +id : null;
  }
}
